/* unplugin-vue-components disabled */import script from "./Signin.vue?vue&type=script&lang=ts&setup=true"
export * from "./Signin.vue?vue&type=script&lang=ts&setup=true"

import "./Signin.vue?vue&type=style&index=0&id=2d9a5ddc&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d9a5ddc"]])

export default __exports__